import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import { Link } from "react-router-dom";
import { cardData, categoryData } from "../../constant/fake-data";
import Button from "../../components/Button/index";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/index";
import Slider from "react-slick";
import AuctionSlider from "../../components/Auction_Card";
import { FaMapMarkerAlt } from "react-icons/fa";
import { BsEnvelopeFill } from "react-icons/bs";
import { FaPhoneAlt } from "react-icons/fa";

const sellersProfileDetail = () => {
  return (
    <div>
      <Header />

      <Banner
        title="Sellers Profile"
        bgImage={IMAGES.HowToBid_Banner_Bg}
        breadcrumbs={["Sellers Profile"]}
      />

      <section className=" main-parent-large-style">
        <div className="container small-container">
          <div className="row">
            <div className="col-md-12">
              <div className="seller-box">
                <div className="image">
                  <img
                    className="seller_profile_bg"
                    src={IMAGES.seller_profile_bg_01}
                    alt=""
                  />
                </div>
                <div className="content-box">
                  <ul className="location">
                    <li>
                      <a href="/">
                        <div className="icon-box">
                          <FaMapMarkerAlt />
                        </div>{" "}
                        201 James St N, Hamilton, Ontario,Canada
                      </a>
                    </li>
                  </ul>
                  <div className="profile-img">
                    <h6>WilliamMotorsCA</h6>
                    <img
                      className="seller_profile_img"
                      src={IMAGES.seller_profile_img_01}
                      alt=""
                    />
                  </div>
                  <ul className="contact-details">
                    <li>
                      <a href="mailto:example@example.com">
                        <div className="icon-box">
                          <BsEnvelopeFill />
                        </div>
                        example@example.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:+123 456 78900">
                        <div className="icon-box">
                          <FaPhoneAlt />
                        </div>
                        +123 456 78900
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className=" upcoming-auction upcoming-auction-sec sellers-page-cards">
  <div className="container small-container">

    <div className="row">
      {cardData.map((val) => (
        <div className="col-md-3 mb-4" key={val.id}>
          <AuctionSlider item={val} />
        </div>
      ))}
    </div>
  </div>
</section>

      <Footer />
    </div>
  );
};

export default sellersProfileDetail;
